import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/react';
import {
  Container,
  Title,
  Alert,
  Text,
  Loader
} from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import SellerMediaGallery from '../../components/seller/SellerMediaGallery';
import { useSession } from '../../api';

const SellerMediaPage = () => {
  const { isLoaded, isSignedIn } = useAuth();
  const { isSeller, status } = useSession();

  // Wait for auth state to settle (Clerk loaded + session role known) before
  // redirecting — otherwise signed-in sellers deep-linking here bounce home.
  if (!isLoaded || status === 'connecting') {
    return (
      <Container size="xl" py="xl">
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
          <Loader size="lg" />
        </div>
      </Container>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/" replace />;
  }

  if (!isSeller) {
    return (
      <Container size="lg" py="xl">
        <Alert
          icon={<IconExclamationCircle size="1rem" />}
          color="pink"
          title="Princess Access Required"
        >
          <Text>
            You need to be a registered princess to access this page.
            Please register as a princess first to manage your gallery.
          </Text>
        </Alert>
      </Container>
    );
  }

  return (
    <Container size="xl" py="xl">
      <Title order={1} mb="xl">My Gallery</Title>
      <SellerMediaGallery />
    </Container>
  );
};

export default SellerMediaPage;
